import {useUserData} from '../../../../hooks'
import {useUiLayoutStore} from '../../../../stores'
import {CabinetSideMenuLinks} from './CabinetSideMenuLinks'
import {CabinetSideMenuUserInfo} from './CabinetSideMenuUserInfo'

// Левое меню в ЛК пользователя с информацией о профиле и ссылками на разделы ЛК.
export function CabinetSideMenu() {

    const user = useUserData()

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    if (
        !user
        || bootstrapSize === 'xs'
        || bootstrapSize === 'sm'
        || bootstrapSize === 'md'
    ) {
        return null
    }

    return (
        <>
            <CabinetSideMenuUserInfo />
            <CabinetSideMenuLinks />
        </>
    )
}
